export enum FormGroupsEnum {
  CUSTOMER_DETAILS = 'customerDetails',
  CONTRACT_ADDRESS = 'contractAddress',
  DELIVERY_ADDRESS = 'deliveryAddress',
  CORRESPONDENCE_ADDRESS = 'correspondenceAddress',
  INSTALLATION_ADDRESS = 'installationAddress',
  DELIVERY_OPTIONS = 'deliveryOptions',
  SELECTED_POS = 'selectedPos',
  PAYMENT_OPTIONS = 'paymentOptions',
  IDENTITY_CONFIRMATION_TYPE = 'identityConfirmationType',
  ID_CART_TYPE = 'idCardType',
}
